"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./../../StudentStatistics.module.css"));
function Footer(props) {
    return (react_1.default.createElement("div", { className: styles.footerPosition },
        react_1.default.createElement("p", null,
            "Asher College ",
            react_1.default.createElement("a", { href: "www.asher.edu" }, "www.asher.edu"))));
}
exports.Footer = Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9vdGVyLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2FzaGVyL1N0dWRlbnRTdGF0aXN0aWNzL3BhcnRzL0Zvb3Rlci9Gb290ZXIuY29tcG9uZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxnREFBeUI7QUFFekIsMkVBQThEO0FBRTlELFNBQWdCLE1BQU0sQ0FBQyxLQUFLO0lBQ3hCLE9BQU8sQ0FDSCx1Q0FBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLGNBQWM7UUFDakM7O1lBQ2tCLHFDQUFHLElBQUksRUFBQyxlQUFlLG9CQUFrQixDQUN2RCxDQUNGLENBQ1QsQ0FBQTtBQUNMLENBQUM7QUFSRCx3QkFRQyJ9